/**
 * Mirrors the query params mixpanel-browser recognises as campaign data
 * (CAMPAIGN_KEYWORDS and CLICK_IDS in its utils.js).
 *
 * Mixpanel already registers the utm_* keys as super properties at init, but
 * those live in a cookie scoped to accounts.disco.ac (cross_subdomain_cookie is
 * false) and are dropped entirely when the visitor declines tracking consent
 * before the SDK loads. Reading them off the URL and putting them on the signup
 * event keeps the attribution attached to the one event that matters.
 */
const CAMPAIGN_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_id',
  'utm_source_platform',
  'utm_campaign_id',
  'utm_creative_format',
  'utm_marketing_tactic',
  'dclid',
  'fbclid',
  'gclid',
  'ko_click_id',
  'li_fat_id',
  'msclkid',
  'sccid',
  'ttclid',
  'twclid',
  'wbraid',
]

export function readCampaignParams(): Record<string, string> {
  try {
    const query = new URLSearchParams(document.location.search)

    return CAMPAIGN_KEYS.reduce<Record<string, string>>((params, key) => {
      const value = query.get(key)

      // Absent keys are left out rather than sent empty, so a campaign-less
      // signup doesn't overwrite anything downstream with blanks.
      if (value) {
        params[key] = value
      }

      return params
    }, {})
  } catch (err) {
    console.error(err)
    return {}
  }
}
